import { User } from '@/features/users/shared/types';

export const retrieveCleaner = (
  cleanerId: number | string | undefined,
  allCleaners: User[] | undefined,
  returnCleanerObject?: boolean
) => {
  const numericCleanerId = Number(cleanerId);

  if (!numericCleanerId) return 'No cleaner assigned';
  if (!allCleaners) return `Counldn't get cleaners list`;
  const cleaner = allCleaners?.find((c) => c.id === numericCleanerId);

  return returnCleanerObject
    ? cleaner
    : `${cleaner?.first_name} ${cleaner?.last_name}` ??
        `Cannot find cleaner with ${numericCleanerId}`;
  // return (
  //   `${cleaner?.first_name} ${cleaner?.last_name}` ??
  //   `Cannot find cleaner with ${cleanerId}`
  // );
};
